import TouchDropdownToggle from "./touch-dropdown-toggle";
import MobileNav from "./mobile-nav";
import ScrollShadow from "../../utility/scroll-shadow";
import Headroom from 'headroom.js';

const HeaderNav = {
  _selectors: {
    headerNav: '.js-header-nav',
    menu: '.js-nav-menu',
    menuItemTopLevel: '.js-nav-menu-item-top-level',
    dropdownContainer: '.js-nav-menu-dropdown',
  },

  init() {
    MobileNav.init();
    TouchDropdownToggle.init();
    ScrollShadow.init();

    const headroom = new Headroom(document.querySelector('.js-header-nav'), {
      tolerance: {
        // Gives a bit of margin when scrolling up before showing the menu
        up: 5,
        down: 10
      },
      // Tracks when the menu is pinned/unpinned on the body element
      onPin: function() {
        document.body.classList.add("menu-pinned");
        document.body.classList.remove("menu-unpinned");
      },
      onUnpin: function() {
        document.body.classList.add("menu-unpinned");
        document.body.classList.remove("menu-pinned");
      }
    });
    headroom.init();
  },
};

export default HeaderNav;